/**
 * This file groups the utility functions used to send data to GA4.
 */
import Vue from 'vue';
Vue.mixin({
  methods: {
    /**
     * Sends sidebar click event
     * @param {string} item
     */
    sendSidebarClickEvent() {
      this.pushAnalyticsEvent('sidebar_nav_click');
    },

    /**************************** Crypto Payout tracking ********************************/

    /**
     * Sends the GA4 event on the direct tab click
     */
    sendPayoutDirectTabClickEvent() {
      this.pushAnalyticsEvent('crypto_payout_direct_tab_click');
    },

    /**
     * Sends the getQuote event 
     */
    sendGetCryptoPayoutDirectQuoteEvent() {
      this.pushAnalyticsEvent('crypto_payout_direct_get_quote');
    },

    sendGetCryptoPayoutDirectQuoteSuccessEvent() {
      this.pushAnalyticsEvent('crypto_payout_direct_get_quote_success');
    },

    /**
     * Sends the create crypto direct payout event
     */
    sendCreateCryptoPayoutDirectEvent() {
      this.pushAnalyticsEvent('create_crypto_payout_direct');
    },

    /**
     * Sends the create crypto direct payout event
     */
    sendCreateCryptoPayoutDirectSuccessEvent() {
      this.pushAnalyticsEvent('create_crypto_payout_direct_success');
    },

    /**
     * Sends the create crypto direct payout event
     */
    sendCreateCryptoPayoutDirectCancelEvent() {
      this.pushAnalyticsEvent('cancel_crypto_payout_direct');
    },

    /**
     * Sends the create crypto direct payout event
     */
    sendCreateCryptoPayoutDirectCancelSuccessEvent() {
      this.pushAnalyticsEvent('cancel_crypto_payout_direct_success');
    },


    pushAnalyticsEvent(eventName) {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      window.dataLayer.push({
        event: eventName,
      });
    }
  }
});